import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LowStockModal } from "./LowStockModal";

export function PrivateRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center">
        <div className="operon-spinner" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <>
      <LowStockModal />
      <Outlet />
    </>
  );
}
